import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

// Animates a number counting up from 0 to `value` using GSAP whenever value changes.
export default function CountUp({ value = 0, duration = 1.2, className = '', prefix = '', suffix = '' }) {
  const ref = useRef(null);
  const proxy = useRef({ val: 0 });

  useEffect(() => {
    const target = Number(value) || 0;
    const tween = gsap.to(proxy.current, {
      val: target,
      duration,
      ease: 'power2.out',
      onUpdate: () => {
        if (ref.current) {
          ref.current.textContent = `${prefix}${Math.round(proxy.current.val).toLocaleString()}${suffix}`;
        }
      },
    });
    return () => tween.kill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return <span ref={ref} className={className}>{prefix}0{suffix}</span>;
}
